import React, { useState, useEffect } from 'react';
import './Temp.css';

const reactorTypes = [
  { name: "BWR", temp: 560 },
  { name: "PWR", temp: 590 },
  { name: "AGR", temp: 870 },
  { name: "MSR", temp: 950 },
];

const Temp = ({ isEmbed = false }) => {

    useEffect(() => {
    if (!isEmbed) return;

    const originalMargin = document.body.style.margin;
    const originalPadding = document.body.style.padding;

    document.body.style.margin = "0";
    document.body.style.padding = "0";

    return () => {
      document.body.style.margin = originalMargin;
      document.body.style.padding = originalPadding;
    };
  }, [isEmbed]);

  const [input, setInput] = useState(500);
  const coldSide = 300;

  const efficiency = input > coldSide ? 1 - coldSide / input : 0;
  const actualEfficiency = Math.max(0, efficiency - 0.25);

  // Slider range
  const min = 500;
  const max = 1000;

  // Convert a temperature into % offset across the slider
  const getPosition = (T) => ((T - min) / (max - min)) * 100;

  return (
    <div className="container">
      <h3 className="cold-side">Cold Side: {coldSide} K</h3>
      <h3 className="actual-efficiency">Effective: {(actualEfficiency * 100).toFixed(2)}%</h3>

      <div className="center-content">
        <h1>Efficiency: {(efficiency * 100).toFixed(2)}%</h1>
      </div>

      <div className="slider-section">
        <h2>Temp: {input} K</h2>
        <input
          type="range"
          min={min}
          max={max}
          value={input}
          onChange={(e) => setInput(Number(e.target.value))}
          className="slider"
        />

        {/* Reactor labels mapped under slider */}
        <div className="labels">
          {reactorTypes.map((r) => (
            <span
              key={r.name}
              className="type"
              style={{ left: `${getPosition(r.temp)}%` }}
            >
              {r.name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Temp;
